import { useService } from 'react-reservice';

import { experienceDemoCreationService } from './service';

export * from './service';

export const useExperienceDemoCreationService = () => {
  return useService(experienceDemoCreationService, (state) => state);
};

export { experienceDemoCreationService };
